import { render } from "./SalesmanShopDayViewModal.vue?vue&type=template&id=0389b6d4"
import script from "./SalesmanShopDayViewModal.vue?vue&type=script&lang=js"
export * from "./SalesmanShopDayViewModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__